import api from "./api";

// =========================================================
// POOLS
// =========================================================
export const fetchIntakePools = async () => {
  const res = await api.get("/intake-qc/pools/");
  return res.data;
};

// 🔥 POOL SUMMARY
export const fetchPoolSummary = async () => {
  const res = await api.get("/intake-qc/pools/summary/");
  return res.data;
};

// =========================================================
// INTAKE
// =========================================================
export const fetchIntakes = async () => {
  const res = await api.get("/intake-qc/intake/");
  return res.data;
};

// 🔥 INTAKE SUMMARY
export const fetchIntakeSummary = async () => {
  const res = await api.get("/intake-qc/intake/summary/");
  return res.data;
};

/**
 * POST /intake-qc/intake/
 */
export const createIntake = async (data) => {
  const res = await api.post("/intake-qc/intake/", data);
  return res.data;
};

// =========================================================
// QC CHECKS
// =========================================================
export const fetchQCChecks = async () => {
  const res = await api.get("/intake-qc/qc/");
  return res.data;
};

/**
 * GET /intake-qc/qc/dashboard/
 *
 * @param {Object} options
 * @param {string} [options.startDate]  ISO date string e.g. "2026-05-26"
 * @param {string} [options.endDate]    ISO date string e.g. "2026-06-02"
 *
 * If neither is provided the backend defaults to the last 7 days.
 */
export const fetchQCDashboard = async ({ startDate, endDate } = {}) => {
  const params = {};
  if (startDate) params.start_date = startDate;
  if (endDate)   params.end_date   = endDate;
  const res = await api.get("/intake-qc/qc/dashboard/", { params });
  return res.data;
};

/**
 * CREATE QC
 */
export const createQCCheck = async (data) => {
  const res = await api.post("/intake-qc/qc/", data);
  return res.data;
};

// =========================================================
// QUARANTINE FLOW
// =========================================================
export const fetchQuarantineQC = async () => {
  const res = await api.get("/intake-qc/qc/quarantine/");
  return res.data;
};

/**
 * APPROVE QC
 */
export const approveQCCheck = async (id, formData) => {
  const res = await api.post(`/intake-qc/qc/${id}/approve/`, formData);
  return res.data;
};

/**
 * REJECT QC
 */
export const rejectQCCheck = async (id, formData) => {
  const res = await api.post(`/intake-qc/qc/${id}/reject/`, formData);
  return res.data;
};